import { put } from "redux-saga/effects";

import { INIT_APP } from "./actions";

function* initAppSaga() {
  // The app has started.
  yield put({ type: INIT_APP });
}

export { initAppSaga };
